{
  "TelnosmovedtoLabel": "Número(s) de telefone movido(s) para:",
  "DevicesmovedfromLabel": "Dispositivo(s) movido(s) de:",
  "AcdagentsmovedfromLabel": "Agente(s) de ACD movidos de:",
  "CallsegmentnumberLabel": "Número do segmento de chamada:",
  "CallsegmentnumberAnyOptionLabel": "[Algum]",
  "CallsegmentnumberFirstOptionLabel": "[Primeiro]",
  "Callsegmentnumber2OptionLabel": "2",
  "Callsegmentnumber3OptionLabel": "3",
  "Callsegmentnumber4OptionLabel": "4",
  "Callsegmentnumber5OptionLabel": "5",
  "Callsegmentnumber6plusOptionLabel": "6+",
  "CallsegmentnumberLastOptionLabel": "[Último]",
  "CallsegmentstartreasonLabel": "Motivo de início do segmento de chamada:",
  "CallsegmentstartreasonAnyOptionLabel": "[Algum]",
  "CallsegmentstartreasonDivertedtoOptionLabel": "Desviado para",
  "CallsegmentstartreasonOverflowedinOptionLabel": "Transbordou",
  "CallsegmentstartreasonAdvancedtoOptionLabel": "Avançado para",
  "CallsegmentstartreasonTransferredtoOptionLabel": "Transferido para",
  "CallsegmentstartreasonConferencedtoOptionLabel": "Conferência para",
  "CallsegmentstartreasonConferencedegenOptionLabel": "Conferência De\/Gen",
  "CallsegmentendreasonLabel": "Motivo de término do segmento de chamada:",
  "CallsegmentendreasonAnyOptionLabel": "[Algum]",
  "CallsegmentendreasonDivertedfromOptionLabel": "Desviado de",
  "CallsegmentendreasonOverflowedoffOptionLabel": "Transbordou",
  "CallsegmentendreasonAdvancedfromOptionLabel": "Avançado de",
  "CallsegmentendreasonTransferredfromOptionLabel": "Transferido de",
  "CallsegmentendreasonConferencedfromOptionLabel": "Conferência de",
  "CallsegmentendreasonConferencedegenOptionLabel": "Conferência De\/Gen",
  "CallsegmentendreasonConsultationtrtoOptionLabel": "Consulta Tr\/To",
  "CallsegmentendreasonMovedtoconferenceOptionLabel": "Movido para a conferência",
  "CallsegmentendreasonMovedtoparkOptionLabel": "Movido para estacionar",
  "CallsegmentendreasonMovedtovoicemailOptionLabel": "Movido para o correio de voz",
  "CallsegmentendreasonEndedonholdonlyOptionLabel": "Terminado apenas em espera",
  "CallsegmentendreasonEndedonholdexclOptionLabel": "Encerrado em espera Excluído",
  "CallsegmentendreasonUnmonitoreddestOptionLabel": "Destino não monitorado",
  "CallsegmentendreasonUnknowndestOptionLabel": "Destino desconhecido",
  "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Apenas todos os destinos não resolvidos",
  "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Todos os destinos não resolvidos excluídos",
  "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Erros de modelagem apenas",
  "CallsegmentendreasonModellingerrorsexclOptionLabel": "Erros de modelagem excluídos",
  "CallsegmentendreasonApplicationendedOptionLabel": "Aplicativo encerrado",
  "CallsegmentendreasonDevicedeletedOptionLabel": "Dispositivo excluído",
  "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "E-mails sem necessidade de resposta excluídos",
  "CallsegmentchainidLabel": "ID da cadeia do segmento de chamada (ID de chamada do aplicativo):",
  "CallMovementFiltering_SectionHeader": "Filtragem de Movimento de Chamada",
  "CallMovementFiltering_AnyPlaceholder": "[Algum]",
  "NAME": "CallMovementFiltering",
  "AcdagentsmovedfromLabel_MST": "Agente(s) transferido(s) de:",
  "CallsegmentstartreasonEscapedtoOptionLabel": "Fugiu para",
  "CallsegmentendreasonEscapedfromOptionLabel": "Fugiu"
}